/**
 * Imports from a previous billing system: the import runs from the command line (`octbill import:legacy`); this page shows
 * each run's report (dry runs included) in the admin sidebar's System section.
 */
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const imports = () => import('./Imports.jsx');

export default {
  name: 'importer',
  adminRoutes: [{ path: 'imports', lazy: page(imports, 'Imports') }],
  adminNav: [
    { section: 'integrations', to: '/admin/imports', label: 'Imports', permission: 'admin.import.run', order: 90 },
  ],
};
